// Canvas setup and the mapping between screen pixels and logical field units.
// The field (FIELD_W x FIELD_H) is letterboxed and centred in the viewport.

import type { Vec2 } from '../core';
import { FIELD_W, FIELD_H } from '../core';

export interface Viewport {
  readonly scale: number;
  readonly offsetX: number;
  readonly offsetY: number;
  readonly dpr: number;
  readonly cssW: number;
  readonly cssH: number;
}

export function computeViewport(cssW: number, cssH: number): Viewport {
  const dpr = window.devicePixelRatio || 1;
  const scale = Math.min(cssW / FIELD_W, cssH / FIELD_H);
  return {
    scale,
    offsetX: (cssW - FIELD_W * scale) / 2,
    offsetY: (cssH - FIELD_H * scale) / 2,
    dpr,
    cssW,
    cssH,
  };
}

export function screenToField(clientX: number, clientY: number, vp: Viewport): Vec2 {
  return { x: (clientX - vp.offsetX) / vp.scale, y: (clientY - vp.offsetY) / vp.scale };
}

/** Sets the context transform so subsequent drawing uses field coordinates. */
export function applyFieldTransform(ctx: CanvasRenderingContext2D, vp: Viewport): void {
  ctx.setTransform(vp.dpr, 0, 0, vp.dpr, 0, 0);
  ctx.translate(vp.offsetX, vp.offsetY);
  ctx.scale(vp.scale, vp.scale);
}

/** Sizes the canvas backing store to the viewport in device pixels. */
export function sizeCanvas(canvas: HTMLCanvasElement, vp: Viewport): void {
  canvas.width = Math.floor(vp.cssW * vp.dpr);
  canvas.height = Math.floor(vp.cssH * vp.dpr);
}
